import React from 'react';
import { LinearProgress, Paper, Typography, Box, Divider, Grid } from '@mui/material';
import {Link} from "react-router-dom";
const InfoCard = ({title, percentage=0, value='...', icon, theme, moreLink=false}) => {
  function LinearProgressWithLabel(props) {
    return (
      <Box sx={{ display: 'flex', alignItems: 'center' }}>
        <Box sx={{ width: '100%', mr: 1 }}>
          <LinearProgress variant="determinate" {...props} />
        </Box>
        <Box sx={{ minWidth: 35 }}>
          <Typography variant="body2" color="text.secondary">{`${Math.round(
            props.value,
          )}%`}</Typography>
        </Box>
      </Box>
    );
  }

  return (
      <Paper elevation={4} className={`dashboard-card-theme-2 ${theme}`}>
        <Box sx={{display: "flex", px: 2}} justifyContent="space-between">
          <Box className="icn-wrapper dashboard-card-icon">
            {icon}
          </Box>
          <Box  sx={{ pt: 2}}>
            <Typography variant="caption" gutterBottom className="dashboard-card-title">{title}</Typography>
            <Typography variant="caption" gutterBottom className="dashboard-card-value">{value}</Typography>
          </Box>
        </Box>
        <Divider 
          sx={{
            backgroundImage: "linear-gradient(to right, rgba(52, 71, 103, 0), rgba(52, 71, 103, 0.4), rgba(52, 71, 103, 0)) !important",
            borderTop: "0px solid rgba(0, 0, 0, 0.12)",
            borderRight: "0px solid rgba(0, 0, 0, 0.12)",
            borderLeft: "0px solid rgba(0, 0, 0, 0.12)",
            borderBottom: "none",
            opacity: 0.55,
            height:"0.0625rem",
            my: 2
          }}
        />
        <Box sx={{ px: 2, pb: 2}} >
          <Grid container >
            <Grid item xs={moreLink?10:12} sm={moreLink?10:12} md={moreLink?10:12} lg={moreLink?10:12} xl={moreLink?10:12}>
              <LinearProgressWithLabel value={percentage} />
            </Grid>
            {moreLink ? (
              <Grid item xs={2} sm={2} md={2} lg={2} xl={2} textAlign="right" sx={{lineHeight: 0}}>
                <Link to={moreLink}><Typography variant="caption" className='more-link' gutterBottom sx={{verticalAlign: 'super', cursor: 'pointer', textDecoration: 'none'}}>More</Typography></Link>
              </Grid> 
            ): null}
          </Grid>
        </Box>
      </Paper>
  );
} 

export default React.memo(InfoCard);
